jQuery.fn.backgroundSwitcher = function ( settings ) {
    var config = {
            breakpoint: 991.98,
            bgDesktop: $( this ).data( 'bg-desktop' ),
            bgMobile: $( this ).data( 'bg-mobile' ),
        },
        self = $( this );

    if ( settings ) jQuery.extend( config, settings );

    changeBackground();

    function changeBackground () {
        var imageURL = config.bgDesktop;

        if ( $( window ).innerWidth() <= config.breakpoint ) {
            imageURL = config.bgMobile;
          }

          self.css( 'background-image', `url(${imageURL})` );

        // if ( self.prop( 'tagName' ) === 'IMG' ) {
        //     if ( self.hasClass( 'lazy' ) && !self.hasClass( 'loaded' ) ) {
        //         self.attr( 'data-src', imageURL );
        //     } else {
        //         self.attr( 'src', imageURL );
        //     }
        // } else if ( [ 'DIV', 'SECTION' ].indexOf( self.prop( 'tagName' ) ) !== -1 ) {
        //     if ( self.hasClass( 'lazy' ) && !self.data( 'wasProcessed' ) ) {
        //         self.attr( 'data-bg', `url(${imageURL})` );
        //     } else {
        //         self.css( 'background-image', `url(${imageURL})` );
        //     }
        // }
    }

    return this;
};



// WEBPACK FOOTER //
// ./scripts/util/backgroundSwitcher.js